import React from "react";

const QualityCheckSmall = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      style={style}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M20.5 12a8.5 8.5 0 11-17 0 8.5 8.5 0 0117 0zm1.5 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-9.524-4.536a.5.5 0 00-.952 0L10.765 9.8a.5.5 0 01-.475.346H7.833a.5.5 0 00-.294.904l1.987 1.445a.5.5 0 01.182.559l-.76 2.337a.5.5 0 00.77.559l1.988-1.445a.5.5 0 01.588 0l1.988 1.445a.5.5 0 00.77-.56l-.76-2.336a.5.5 0 01.181-.56l1.988-1.444a.5.5 0 00-.293-.904H13.71a.5.5 0 01-.475-.346l-.76-2.336z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export default QualityCheckSmall;
